import { jsx as u } from "react/jsx-runtime";
import "react";
import '../../assets/MultiLayeredFigure.css';const l = {
  "multi-layered-figure": "_multi-layered-figure_b1yqx_1",
  "multi-layered-figure__images": "_multi-layered-figure__images_b1yqx_6"
};
function _({ images: t = [], positions: g = ["center"], sizes: o = ["auto"] }) {
  const a = (r = [], c = "") => {
    let i = "";
    for (let e = 0; e < r.length; e++)
      c === "image" ? e === 0 ? i += `url("${r[e]}")` : i += `,url("${r[e]}")` : e === 0 ? i += `${r[e]}` : i += `,${r[e]}`;
    return i;
  }, s = a(g), n = a(t, "image"), m = a(o);
  return /* @__PURE__ */ u("figure", { className: l["multi-layered-figure"], children: /* @__PURE__ */ u(
    "div",
    {
      className: l["multi-layered-figure__images"],
      style: {
        backgroundImage: n,
        backgroundPosition: s,
        backgroundSize: m
      }
    }
  ) });
}
export {
  _ as MultiLayeredFigure,
  _ as default
};
